import * as d3 from "d3";
import { useLayoutEffect, useRef } from "react";

interface DateTimelineChartGridPropsType {
  chartGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  gridStyle: {
    opacity?: number;
    strokeDasharray?: string;
  };
  height: number;
  isXGridVisible: boolean;
  isYGridVisible: boolean;
  width: number;
  xScale: d3.ScaleBand<Date>;
  yScale: d3.ScaleLinear<number, number>;
}

export function DateTimelineChartGrid({
  chartGroup: g,
  gridStyle,
  height,
  isXGridVisible,
  isYGridVisible,
  width,
  xScale,
  yScale,
}: DateTimelineChartGridPropsType) {
  const xGridRef = useRef<d3.Selection<
    SVGGElement,
    unknown,
    null,
    undefined
  > | null>(null);
  const yGridRef = useRef<d3.Selection<
    SVGGElement,
    unknown,
    null,
    undefined
  > | null>(null);

  useLayoutEffect(() => {
    if (!g) return;

    const xGrid = d3
      .axisBottom(xScale)
      .tickSize(-height)
      .tickFormat(() => "");

    if (!xGridRef.current) {
      xGridRef.current = g.append("g").attr("class", "chart-grid-lines x-grid");
    }

    xGridRef.current
      .attr("transform", `translate(0,${height})`)
      .interrupt()
      .call(xGrid)
      .call((g) => g.select(".domain").remove())
      .attr("shape-rendering", "crispEdges")
      .style("stroke-dasharray", gridStyle.strokeDasharray)
      .style("opacity", isXGridVisible ? gridStyle.opacity : 0);

    const yTickValues = yScale.ticks().filter((tick) => tick > 0);
    const yGrid = d3
      .axisLeft(yScale)
      .tickSize(-width)
      .tickValues(yTickValues)
      .tickFormat(() => "");

    if (!yGridRef.current) {
      yGridRef.current = g.append("g").attr("class", "chart-grid-lines y-grid");
    }

    yGridRef.current
      .interrupt()
      .call(yGrid)
      .call((g) => g.select(".domain").remove())
      .attr("shape-rendering", "crispEdges")
      .style("stroke-dasharray", gridStyle.strokeDasharray)
      .style("opacity", isYGridVisible ? gridStyle.opacity : 0);
  }, [
    g,
    xScale,
    yScale,
    width,
    height,
    isXGridVisible,
    isYGridVisible,
    gridStyle,
  ]);

  return null;
}
